<template>
  <rabbey-base-drawer
    ref="drawerNavNav"
    title="Diferencia de equipos entre Navision y Navixy"
    size="80%"
    :drawer="drawer"
    v-on:update:drawer="$emit('update:drawer', $event)"
  >
    <el-row>
      <el-col>
        <rabbey-table3
          :columns="columns"
          :data="itemsRender"
          row-key="RowIndex"
          show-summary
          default-expand-all
        ></rabbey-table3>
      </el-col>
    </el-row>
    <contractDetails ref="contractNavisionDetails" />
    <equimentNavixyDetails ref="equimentNavixyDetails" />
  </rabbey-base-drawer>
</template>

<script>
import flow from "lodash/fp/flow";
import map from "lodash/fp/map";
import groupBy from "lodash/fp/groupBy";
import contractDetails from "@/components/customers/TableContractsNav.vue";
import equimentNavixyDetails from "@/components/customers/TableEquimentNav.vue";
// import HyperLink from "@/components/functionals/HyperLinkContract.vue";

export default {
  name: "NavisionAndNavixy",
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    items: Array
  },
  components: {
    contractDetails,
    equimentNavixyDetails
  },
  data() {
    return {
      columns: [
        {
          prop: "ClientCode",
          label: "Código Navisión",
          sortable: true,
          width: 155,
          fixed: true
        },
        {
          prop: "Name",
          label: "Nombre",
          minWidth: 150,
          fixed: true,
          sortable: true
        },
        {
          prop: "NavisionQty",
          label: "Equipos en Contrato",
          minWidth: 180,
          // cellAtrrs: {
          //   tbl: "table",
          //   OpenSelect: this.OpenSelect
          // },
          // formatter: HyperLink,
          sortable: true
        },
        {
          prop: "NavixyQty",
          label: "Equipos en Navixy",
          sortable: true,
          minWidth: 190
          // cellAtrrs: {
          //   tbl: "table",
          //   OpenSelect: this.OpenSelect
          // },
          // formatter: HyperLink
        },
        {
          prop: "NavixyCloneQty",
          label: "Diferencia",
          sortable: true,
          width: 160,
          formatter: (row) => Math.abs(row.NavisionQty - row.NavixyQty),
          "sort-by": (row) => Math.abs(row.NavisionQty - row.NavixyQty)
        },
        {
          prop: "NavixyCloneQty",
          label: "Clones",
          sortable: true,
          width: 100
        },
        {
          prop: "NavixyClientCode",
          label: "Código Región",
          minWidth: 170,
          sortable: true
        },
        {
          prop: "NavixyName",
          label: "Nombre de usuario Navix",
          minWidth: 210,
          sortable: true
        }
      ]
    };
  },
  methods: {
    OpenSelect(props) {
      if (props.column === "NavisionQty") {
        this.$refs.contractNavisionDetails.show(props);
      } else if (props.column === "NavixyQty") {
        this.$refs.equimentNavixyDetails.show(props);
      }
    }
  },
  computed: {
    itemsRender() {
      const items = flow(
        groupBy("ClientCode"),
        map((records) => {
          // almacena el primer registro
          const firstRecord = records[0];
          // elimina el primer registro
          records.splice(0, 1);

          // arma el objeto agregando su children para el tree
          return {
            ...firstRecord,
            children: records
          };
        })
      )(this.items);
      return items;
    }
  }
};
</script>

<style lang="scss" scoped>
.tags span:not(:first-child) {
  margin-left: 5px;
}
.el-table .warning-row {
  background: red;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
